module.exports = __webpack_public_path__ + "static/media/ehealth_pro_activiate_step_4.e19b3845.png";